export const IMAGE_WIDTH = 70
export const IMAGE_HEIGHT = 58
export const WIDESCREEN_HEIGHT = 50
export const WIDESCREEN_RATIO: number = 9 / 16
export const WIDESCREEN_PERCENT: number = 9 / 16 * 100
export const WIDESCREEN_WIDTH: number = WIDESCREEN_HEIGHT / WIDESCREEN_RATIO
